import * as types from '@/store/mutation-types'
import { apiNameList, api, staticApi } from '@/api/index'
import { viewNameList } from '@/api/view'
import '@/util/extends/toFirstUpperCase'
import Vue from 'vue'
import router from '@/router/index'

let checkGetters = {}
// let checkList = [].concat(apiNameList,viewNameList);
let checkList = viewNameList
checkList.forEach((v) => {
  checkGetters[v] = function (state) {
    return state.access.find((x) => x.permission === v)
  }
})
//通用模块状态控制
const authModule = {
  state: {
    user: null, //用户信息
    // token:"",
    access: [],
    permission: null,
    /**
     * 获取用户所有菜单
     * @Author BillionChen
     * @param  {[type]}    state [description]
     * @return {[type]}          [description]
     */
    menuTree: [],
    marketLineList: [],
    // 事业线
    classifyList: '',
    // 品牌品类
    brandCategorys: [],
  },

  //激发事件改变state
  mutations: {
    //成功登录事件
    [types.AUTH_LOGIN](state, n) {
      state.user = n.user
    },
    //退出登录/登录失效
    [types.AUTH_LOGOUT](state) {
      api.system.oauthLogout().then((res) => {
        console.log('登出方法调用')
        if (res.status) {
          window.location =
            res.data + encodeURIComponent(location.href) + '&AppCode=OPUC&SubAppCode=OPUCPC001'
        }
      })
    },
    //成功获取用户权限
    [types.AUTH_ACCESS](state, n) {
      state.access = n
      /**
       * 组合用户权限/菜单
       * @Author BillionChen
       * @param  {Array}     arr [description]
       * @param  {Number}    pid [description]
       * @return {[type]}        [description]
       */
      function mergeAccess(arr = [], pid = 0) {
        return arr
          .filter((v) => {
            return v.parentId === pid
          })
          .sort((a, b) => a.sort - b.sort)
          .map((v, k) => {
            v.open = false
            v.active = !!(v.href && router.currentRoute.fullPath.indexOf(v.href) > -1)
            v.children = mergeAccess(arr, v.id)
            v.children.forEach((child) => {
              if (child.active === true) {
                v.active = true
                v.open = true
              }
            })
            return v
          })
      }
      state.permission = state.access
        .filter((i) => {
          return i.permission
        })
        .map((j) => {
          return j.permission
        })
        .join('|')

      state.menuTree = mergeAccess(
        state.access.filter((v) => v.isShow === 1),
        '25c886f190914d9caf3d7a1e684feea1'
      )
    },
    //部门树形结构数据
    [types.GET_MARKET_LINE_LIST](state, n) {
      state.marketLineList = n
      window.sessionStorage.setItem('circularsTree', JSON.stringify(n))
    },

    //展开/关闭menuTree
    menuToggle(state, index) {
      state.menuTree.forEach((v, k) => {
        state.menuTree[k].open = false
      })
      Vue.set(
        state.menuTree,
        index,
        Object.assign(
          {},
          {
            ...state.menuTree[index],
            open: !state.menuTree[index].open,
          }
        )
      )
    },
    routerRefresh(state, index) {
      state.menuTree.forEach((v, k) => {
        state.menuTree[k].active = false
      })
      Vue.set(
        state.menuTree,
        index,
        Object.assign(
          {},
          {
            ...state.menuTree[index],
            active: true,
          }
        )
      )
    },
    setClassifyList(state, val) {
      state.classifyList = val
    },
    setBrandCategorys(state, val) {
      state.brandCategorys = val
    },
  },
  //异步操作拿远程数据,然后提交事件
  actions: {
    async getMenusByUser({ commit, dispatch, state }) {
      //获取 权限
      try {
        let res = await api.menu.listByUser({
          userId: state.user.id,
          platformType: 'UCENTER',
        })
        if (res.status) {
          commit(types.AUTH_ACCESS, res.data.menuList)
        }
      } catch (err) {
        console.log(err, '获取权限异常 ')
      }
    },
    //检查登录操作
    checkLogin({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        api.user
          .getCurrent()
          .then((res) => {
            if (res.status) {
              sessionStorage.setItem('userInfo', JSON.stringify(res.data))
              commit(types.AUTH_LOGIN, { user: res.data }) //触发登录成功事件
              dispatch('getCurrentLine')
              dispatch('getBrandCategorys')
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getCurrentLine({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        api.user
          .getCurrentLine({ accountId: state.user.id })
          .then((res) => {
            let userInfo = state.user
            if (res.status) {
              let classifyList = res.data.map((x) => x.orgBelongMarketClassifyName).join(',')
              userInfo.classifyList = classifyList
              commit('setClassifyList', classifyList)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getBrandCategorys({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        api.user
          .getUserBrandConfigureList({ userId: state.user.id })
          .then((res) => {
            if (res.status) {
              commit('setBrandCategorys', res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },

  //频繁通用计算
  getters: {
    ...checkGetters,
  },
}

export default authModule
